import { z } from 'zod';

import { FinancialAmountModel } from './financial-amount.model';

export const DepositModel = z.object({
  paid: FinancialAmountModel.optional(),
  date: z.string().optional(),
});
